module.exports = __webpack_public_path__ + "img/mentol.a6c22405.png";